interface SortableHeaderProps<T extends string> {
  label: string;
  field: T;
  sortField: T | null;
  sortDirection: 'asc' | 'desc';
  onSort: (field: T) => void;
  className?: string;
}

function SortIcon({ active }: { active: boolean }) {
  return (
    <svg
      width='16'
      height='16'
      viewBox='0 0 24 24'
      fill='none'
      className={`shrink-0 ${active ? 'text-gray-900' : 'text-gray-400'}`}
    >
      <path
        d='M7 4V20M7 4L3 8M7 4L11 8M17 20V4M17 20L13 16M17 20L21 16'
        stroke='currentColor'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
}

export function SortableHeader<T extends string>({
  label,
  field,
  sortField,
  sortDirection,
  onSort,
  className = '',
}: SortableHeaderProps<T>) {
  return (
    <div className={`flex flex-1 items-center gap-1.5 min-h-px min-w-[100px] ${className}`}>
      <button
        type='button'
        onClick={() => onSort(field)}
        className='inline-flex items-center gap-1.5 text-sm font-medium leading-5 text-gray-900 hover:text-gray-700'
      >
        {label}
        <SortIcon active={sortField === field} />
      </button>
    </div>
  );
}
